import ExpandableStrollerCard, {
  ExpandableStrollerCardType,
} from './ExpandableStrollerCard';
export { ExpandableStrollerCardType };

export default ExpandableStrollerCard;
